import React from "react";
import { Route, Navigate } from "react-router-dom";
import { isAuthenticated } from "../services/account.service";
import Employees from "../components/co-owner/employees";
import CoOwnerProfile from "../components/co-owner/profile/coOwnerProfile";
import Loader from "../common/loader";
import NotFoundPage from "../components/errors/404";
import { ROLES } from "../constants/general.constant";
import Customers from "../components/common/customerDetails";
import Leads from "../components/common/leads";
import CustomerProfile from "../components/common/customerProfile/customerProfile";
import Bankers from "../components/common/bankerDetails";
import MainLayout from "../layout/mainLayout";
import {useAuth} from "../hook/userRoleHook";
import DealsPage from "../components/customers/deals";
import InactiveDealsPage from "../components/customers/inactiveDeals";
import Notifications from "../components/customers/notifications";
import TaskManager from "../components/business/tasks/TaskManager";

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { role, loading, redirectionUrl, isLoginPage } = useAuth();

  if (!isAuthenticated() && !isLoginPage) {
    return <Navigate to={redirectionUrl} replace />;
  }

  if (loading) return <Loader />;

  if (role !== ROLES.CO_OWNER) return <NotFoundPage />;

  return <>{children}</>;
};

const WithLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ProtectedRoute>
    <MainLayout>{children}</MainLayout>
  </ProtectedRoute>
);

const WithoutLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ProtectedRoute>{children}</ProtectedRoute>
);

const coOwnerRoutesConfig = [
  { key: "employees", path: "/co-owner/employees", element: <Employees />, layout: "with" },
  { key: "profile", path: "/co-owner/your-profile", element: <CoOwnerProfile />, layout: "with" },
  { key: "customers", path: "/co-owner/customers", element: <Customers />, layout: "with" },
  { key: "leads", path: "/co-owner/leads", element: <Leads />, layout: "with" },
  { key: "customer-profile", path: "/co-owner/customers/:customerId", element: <CustomerProfile />, layout: "without" },
  { key: "bankers", path: "/co-owner/bankers", element: <Bankers />, layout: "with" },
  { key: "notifications", path: "/co-owner/notifications", element: <Notifications />, layout: "with" },
  { key: "tasks", path: "/co-owner/tasks", element: <TaskManager />, layout: "with" },
  { key: "deals", path: "/co-owner/deals", element: <DealsPage />, layout: "with" },
  { key: "inactive-deals", path: "/co-owner/inactive-deals", element: <InactiveDealsPage />, layout: "with" },
];

const CoOwnerRoutes = coOwnerRoutesConfig.map(({ key, path, element, layout }) => (
  <Route
    key={key}
    path={path}
    element={layout === "with" ? <WithLayout>{element}</WithLayout> : <WithoutLayout>{element}</WithoutLayout>}
  />
));

export default CoOwnerRoutes;
